class ComparisonChart extends HTMLElement {
  constructor() {
    super();

    this.heading = this.querySelector("[data-heading]");
    this.pro2Button = this.querySelector("[data-switch-button-2]");
    this.proButton = this.querySelector("[data-switch-button]");

    this.pro2Button.addEventListener("click", this.renderPro2Chart.bind(this));
    this.proButton.addEventListener("click", this.renderProChart.bind(this));

    this.pro2Table = this.querySelector(
      ".comparison-chart__table[data-table-type='pro2']"
    );
    this.proTable = this.querySelector(
      ".comparison-chart__table[data-table-type='pro']"
    );

    this.renderPro2Chart();
  }

  renderPro2Chart() {
    this.heading.textContent = "Orion Pro 2.0";
    this.pro2Button.classList.add("active");
    this.proButton.classList.remove("active");

    this.pro2Table.classList.add("active");
    this.proTable.classList.remove("active");
  }

  renderProChart() {
    this.heading.textContent = "Orion Pro";
    this.proButton.classList.add("active");
    this.pro2Button.classList.remove("active");

    this.pro2Table.classList.remove("active");
    this.proTable.classList.add("active");
  }
}

customElements.define("comparison-chart", ComparisonChart);

class ComparisonChartTable extends HTMLElement {
  constructor() {
    super();

    const slider = $(
      `[data-table-type="${this.dataset.tableType}"] [data-product-slider]`
    );
    slider.slick({
      arrows: false,
      slidesToShow: 5,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2
          }
        }
      ]
    });

    const sliderLeftButton = this.querySelector(
      "[data-product-slider-arrow-left]"
    );
    sliderLeftButton.addEventListener("click", function () {
      slider.slick("slickPrev");
    });

    const sliderRightButton = this.querySelector(
      "[data-product-slider-arrow-right]"
    );
    sliderRightButton.addEventListener("click", function () {
      slider.slick("slickNext");
    });
  }
}

customElements.define("comparison-chart-table", ComparisonChartTable);
